import { toString } from 'lodash'
import moment from 'moment'

export default (data = [], filterItems) => {
  return filterItems.map((filter) => {
    if (!filter.quickFilter) {
      filter.count = data.length
    } else {
      Object.keys(filter.quickFilter).forEach(filterItem => {
        const { filterType, type, filter: filterValue, filterTo: filterValueTo, dateTo, dateFrom } = filter.quickFilter[filterItem]
        // simple number filter for equal values
        if (filterType === 'number' && type === 'equals') {
          const items = data.filter(item => item[filterItem] === filterValue)
          filter.count = items.length

        // simple number filter for less than values
        } else if (filterType === 'number' && type === 'lessThan') {
          const items = data.filter(item => item[filterItem] <= filterValue)
          filter.count = items.length
        // simple number filter for greater than values
        } else if (filterType === 'number' && type === 'greaterThan') {
          const items = data.filter(item => item[filterItem] >= filterValue)
          filter.count = items.length
        // more complex number filter for value ranges
        } else if (filterType === 'number' && type === 'inRange') {
          const items = data.filter(item => item[filterItem] >= filterValue && item[filterItem] <= filterValueTo)
          filter.count = items.length
        // simple text filter, checks if row data contains certain string
        } else if (filterType === 'text' && type === 'contains') {
          const items = data.filter(item => item[filterItem].indexOf(filterValue) !== -1)
          filter.count = items.length
        // more complex date filter, checks if given date is in range
        } else if (filterType === 'date' && type === 'inRange') {
          const items = data.filter(item => {
            const date = item[filterItem]
            return moment(date).isBetween(moment(dateFrom).subtract(1, 'days'), moment(dateTo).subtract(1, 'days'))
          })
          filter.count = items.length
        } else {
          filter.count = Object.keys(filter.quickFilter).reduce((result, current) => {
            return result.filter(item => {
              const dataItem = item.data ? item.data : item
              return filter.quickFilter[current].values.includes(toString(dataItem[current]))
              || (dataItem.metaData ? filter.quickFilter[current].values.includes(toString(dataItem.metaData[current])) : false)
            })
          }, data).length
        }
      })
    }
    return filter
  })
}
